module.exports = __webpack_public_path__ + "img/guidelines-03.851edf8f.png";